import { render, staticRenderFns } from "./CmgOrderConfirmationCancelOrderSuccessModal.vue?vue&type=template&id=21d07845&scoped=true&lang=pug"
import script from "./cmg-order-confirmation-cancel-order-success-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-confirmation-cancel-order-success-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderConfirmationCancelOrderSuccessModal.vue?vue&type=style&index=0&id=21d07845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d07845",
  null
  
)

export default component.exports